import { CloseCircleTwoTone } from "@ant-design/icons";
import { Card, Col, Row } from "antd";

export function Header() {
  return (
    <Card bodyStyle={{ padding: 12 }}>
      <Row align="middle" justify="space-between">
        <Col>
          <Row align="middle">
            <CloseCircleTwoTone style={{ marginRight: 12, fontSize: 38 }} twoToneColor={["red", "#ffcccb"]} />
            <div style={{ fontSize: 24, fontFamily: "azonix" }}>Cancel</div>
          </Row>
        </Col>
      </Row>
    </Card>
  );
}
